/* eslint-disable import/no-unresolved */

// The rule above to shut ESLint from complaining
// about unresolved Swiper's CSS imports
// Why? see: https://github.com/import-js/eslint-plugin-import/issues/2266

import { useRef } from 'react';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper';
import { Navigation } from 'swiper/modules';

import { VehicleImageViewModel } from '@api/index';
import { DEFAULT_IMAGE } from '@constants/constants';
import { Image } from '@shared';

import {
  CarCarouselDotsWrapper,
  CarCarouselItem,
  CarCarouselWrapper,
  CircleButton,
} from '../CarRentalCard.styled';

interface ICarCarousel {
  handleCarouselChange: (index: number) => void;
  vehicles: Array<VehicleImageViewModel>;
  activeIndex: number;
}

const CarCarousel: React.FC<ICarCarousel> = ({
  handleCarouselChange,
  vehicles,
  activeIndex,
}) => {
  const swiperRef = useRef<SwiperType | null>(null);

  return (
    <CarCarouselWrapper>
      {vehicles.length > 1 ? (
        <CarCarouselDotsWrapper>
          <CircleButton
            disabled={activeIndex === 0}
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <LeftOutlined />
          </CircleButton>
          <CircleButton
            disabled={activeIndex === vehicles.length - 1}
            onClick={() => swiperRef.current?.slideNext()}
          >
            <RightOutlined />
          </CircleButton>
        </CarCarouselDotsWrapper>
      ) : null}
      <Swiper
        onRealIndexChange={(swiper) => handleCarouselChange(swiper.realIndex)}
        modules={[Navigation]}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
        speed={600}
      >
        {vehicles.map((vehicle, i) => (
          <SwiperSlide key={i}>
            <CarCarouselItem>
              <Image
                src={vehicle?.image ?? DEFAULT_IMAGE}
                alt={vehicle?.name || ''}
                height={179}
                width={450}
              />
            </CarCarouselItem>
          </SwiperSlide>
        ))}
      </Swiper>
    </CarCarouselWrapper>
  );
};

export default CarCarousel;
